function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var $c1905b78f6d2f5bf$exports = require("./intlStrings.main.js");
var $2nNUW$reactariai18n = require("@react-aria/i18n");
var $2nNUW$react = require("react");
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}
$parcel$export(module.exports, "useDisplayNames", function () {
  return $934ac650a0aceb4b$export$d42c60378c8168f8;
});
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // @ts-ignore

function $934ac650a0aceb4b$export$d42c60378c8168f8() {
  var _ref = (0, $2nNUW$reactariai18n.useLocale)(),
    locale = _ref.locale;
  var dictionary = (0, $2nNUW$reactariai18n.useLocalizedStringDictionary)((0, $parcel$interopDefault($c1905b78f6d2f5bf$exports)), '@react-aria/datepicker');
  return (0, $2nNUW$react.useMemo)(function () {
    // Try to use Intl.DisplayNames if possible. It may be supported in browsers, but not support the dateTimeField
    // type as that was only added in v2. https://github.com/tc39/intl-displaynames-v2
    try {
      return new Intl.DisplayNames(locale, {
        type: 'dateTimeField'
      });
    } catch (_unused) {
      return new $934ac650a0aceb4b$var$DisplayNamesPolyfill(locale, dictionary);
    }
  }, [locale, dictionary]);
}
var $934ac650a0aceb4b$var$DisplayNamesPolyfill = /*#__PURE__*/function () {
  function $934ac650a0aceb4b$var$DisplayNamesPolyfill(locale, dictionary) {
    _classCallCheck(this, $934ac650a0aceb4b$var$DisplayNamesPolyfill);
    this.locale = locale;
    this.dictionary = dictionary;
  }
  return _createClass($934ac650a0aceb4b$var$DisplayNamesPolyfill, [{
    key: "of",
    value: function of(field) {
      return this.dictionary.getStringForLocale(field, this.locale);
    }
  }]);
}();